module.exports = __webpack_public_path__ + "img/close_black.e2c129ee.svg";